import React, { useState, useEffect, useContext } from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'

import ConfirmModal from '../../ConfirmModal/index'
import ConfirmAction from '../ConfirmDelete/index'
import DocumentsModal from '../../Document/index'
import AlertModal from '../../AlertModal/index'

import DocumentsIcon from '../../../../assets/Icons/ModalPJ/documents.svg'
import RedDocs from '../../../../assets/Icons/ModalPJ/redDocs.svg'
import BlockIcon from '../../../../assets/Icons/ModalPJ/block.svg'
import UnBlockIcon from '../../../../assets/Icons/ModalPJ/unblock.svg'
import AlertIcon from '../../../../assets/Icons/ModalPJ/alert.svg'
import ApproveIcon from '../../../../assets/Icons/ModalPJ/aprove.svg'
import GreenApproveIcon from '../../../../assets/Icons/ModalPJ/greenApprove.svg'
import TrashIcon from '../../../../assets/Icons/ModalPJ/trash.svg'
import Confirm from '../../../../assets/Icons/ModalPJ/_confirm.svg'
import Decline from '../../../../assets/Icons/ModalPJ/_decline.svg'
import Cross from '../../../../assets/Icons/cross.svg'

import MyContext from '../../../../contexts/_ModalData/modal'
import api from '../../../../services/api'
import './styles.css'

export default ({show, setShow, changeStatus }) => {

    const[showApprove, setShowApprove] = useState(false);
    const[approveRegister, setApproveRegister] = useState(false);
    // const[isBlocked, setIsBlocked] = useState(false)

    const[showModalConfirm, setShowModalConfirm] = useState(false);
    const[title, setTitle] =  useState('');
    const[text, setText] =  useState('');

    const[showDocuments, setShowDocuments] = useState(false);
    const[imgCPF, setImgCPF] = useState('');
    const[imgEstablishment, setImgEstablishment] = useState('');
    
    const[showConfirmAction, setShowConfirmAction] = useState(false);
    const[textConfirm, setTextConfirm] = useState('');

    const[isBlocked, setIsBlocked] = useState(false);
    const[showProgress, setShowProgress] = useState(false);

    const[showAlertModal, setShowAlertModal] = useState(false);
    const[alertMessage, setAlertMessage] = useState('');

    const { dataPJ } = useContext(MyContext)

    useEffect(() => {
        console.log(dataPJ)
        // setIsBlocked(dataPJ.blocked)
    }, [dataPJ]);

    const handleClose=()=>{
        setShow(false)
        setApproveRegister(false)
    }

    /*******DOCUMENTS **/
    const handleDocuments = () => {
        // setShowDocuments(true)
        getDocuments()
    }

    const getDocuments = async()=>{
        await api.get('/admin/getDocuments',
            {
                headers: {
                    authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
                    uid:dataPJ.firebaseUID
                }
            }
        ).then(response=>{
            // console.log(response)
            setImgCPF(response.data.cpf.url)
            setImgEstablishment(response.data.establishment ? response.data.establishment.url : 'ntem')
            setShowDocuments(true)
            // console.log(docsData)
        }).catch(error=>{
            //////colocar msg de erro

            setShowModalConfirm(false)//closes the first modal
            setShowConfirmAction(true)
            setTextConfirm('Erro ao carregar documentos!')
        })
    }
    /**************** */

    /*******BLOCK***** */
    const handleBlock = () =>{
        setTitle('Bloquear')
        setText('Deseja bloquear esse usuário?')
        setShowModalConfirm(true)
    }

    const handleUnBlock = () =>{
        setTitle('Desbloquear')
        setText('Deseja desbloquear esse usuário?')
        setShowModalConfirm(true)
    }

    const blockFunc = async() =>{
        console.log('block')

        const bodyParameters = {
            key: "value"
        }
        const config = {
            headers: {
                authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
            },
        }

        await api.put(`/admin/block?uid=${dataPJ.firebaseUID}&type=legalEntity`, bodyParameters,
            config
        ).then(() => {
            setIsBlocked(true);
            //console.log(response);
            setShowModalConfirm(false);//closes the first modal
            setShowConfirmAction(true);//calls the confirmation modal
            setTextConfirm('Usuário bloqueado com sucesso!');//sets the confirmation modal message
            changeStatus();//makes another api call
            setShow(false);//closes the main modal
            setShowProgress(false);//to disable the circular progress
            handleSendEmail();//sends block email to user

            sendNotifications(`Você foi bloqueado do sistema. \nEmail: ${dataPJ.email}`, `Bloqueio de conta!`, 'legalEntity', dataPJ.firebaseUID)

        }).catch(() => {
            setShowModalConfirm(false);//closes the first modal
            setShowConfirmAction(true);
            setTextConfirm('Erro ao bloquear usuário!');
            setShowProgress(false);//to disable the circular progress

        })
    }

    const handleSendEmail = async() =>{
        const data = {
            email: dataPJ.email,
            text:`Olá ${dataPJ.name},\n Devido a analise, a sua conta foi bloqueada pela administração.
                Entre em contato com o suporte para mais informações.`,
            subject:"Bloqueio no Aplicativo de Segurança da Mulher"
        }

        await api.post('/admin/sendEmail', data,
            {
                headers: {
                    authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
                },
            }
        ).catch(() =>{
            //console.log(error);
            setTextConfirm('Erro ao confirmar cadastro de ouvidoria!')
        })
    }

    const unblockFunc = async () =>{
        // const data = {
        //     type:'legalEntity',
        //     uid:dataPJ.firebaseUID,
        // }

        const bodyParameters = {//prevents the body from being null
            key: "value"
        }

        await api.put(`/admin/unblock?uid=${dataPJ.firebaseUID}&type=legalEntity`, bodyParameters,
            {
                headers: {
                    authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
                }
            }
        ).then(() =>{
            setIsBlocked(false)

            setShowModalConfirm(false)//closes the first modal
            setShowConfirmAction(true)//calls the confirmation modal
            setTextConfirm('Usuário desbloqueado com sucesso!')//sets the confirmation modal message
            changeStatus()//makes another api call
            setShow(false)//closes the main modal
            setShowProgress(false)//to disable the circular progress

            // console.log(response);
        }).catch(() =>{
            setShowModalConfirm(false)//closes the first modal
            setShowConfirmAction(true)
            setTextConfirm('Erro ao desbloquear usuário!')
            setShowProgress(false)//to disable the circular progress

        })
    }
    
    /***************** */

    /*****ALERT******* */
    const handleAlert = () =>{
        setTitle('Alertar')
        setText('Deseja emitir um alerta de mau uso do aplicativo para esse usuário?')
        setShowAlertModal(true);
    }
    const alertFunc = async() =>{
        console.log('alertPJ');

        const data = {
            email:dataPJ.email,
            text:alertMessage,
            subject:"Alerta do Aplicativo de Segurança da Mulher",
        }
        //console.log('AlentMessage PJ', alertMessage);
       
        await api.post('/admin/sendEmail', data,
            {
                headers: {
                    authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
                },
            }
        ).then(()=>{
            // setIsBlocked(false)

            setShowAlertModal(false);//closes the first modal
            setShowConfirmAction(true);//calls the confirmation modal
            setTextConfirm('Alerta enviado com sucesso!');//sets the confirmation modal message
            setShowProgress(false);//to disable the circular progress
            sendNotifications(`Email: ${dataPJ.email}\n`+ alertMessage, `Você recebeu um alerta!`, 'legalEntity', dataPJ.firebaseUID);

            // setShow(false)//closes the main modal
            // console.log(response);
        }).catch(error=>{
            console.log(error);
            setShowAlertModal(false);//closes the first modal
            setShowConfirmAction(true);
            setTextConfirm('Erro ao enviar alerta!');
            setShowProgress(false);//to disable the circular progress
        })

    }
    /***************** */

    /*****APPROVE***** */
    const handleApprove = () =>{
        setTitle('Aprovar Cadastro');
        setText('Deseja aprovar esse usuário?');
        setShowModalConfirm(true);
    }
    const handleDenyApprove = () =>{
        setApproveRegister(false)
        setShowApprove(false)
    }

    const handleApproveConfirm = async() =>{

        await api.put('/admin/acceptUser', {uid:dataPJ.firebaseUID},
            {
                headers: {
                    authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
                }
            }
        ).then(response=>{
            console.log(response)
            setApproveRegister(true)//shows green icon
            setShowApprove(false)

            setShowModalConfirm(false)//closes the first modal
            setShowConfirmAction(true)//calls the confirmation modal
            setTextConfirm('Cadastro aprovado com sucesso!')//sets the confirmation modal message

            sendEmail('Seu cadastro ao Aplicativo de Segurança da Mulher foi liberado, você já pode acessar o sistema através do App.', 'Mensagem do Aplicativo de Segurança da Mulher')

            changeStatus()
        }).catch( () =>{
            setShowModalConfirm(false)//closes the first modal
            setShowConfirmAction(true)
            setTextConfirm('Erro ao aprovar cadastro. Verifique se o usuário possui todos os documentos!')
        })
    }
    /***************** */

    /*******DELETE**** */
    const handleDelete = () =>{
        setTitle('Excluir')
        setText('Deseja excluir esse usuário permanentemente?')
        setShowModalConfirm(true)
    }
    
    const deleteFunc = async() =>{

        await api.delete(`/admin/deleteUser?uid=${dataPJ.firebaseUID}&type=legalEntity`,
        {
            headers: {
                authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
                
            },
        }
        ).then(response=>{
            // console.log('delete')
            console.log(response)
            
            setShowModalConfirm(false)//closes the first modal
            setShowConfirmAction(true)//calls the confirmation modal
            setTextConfirm('Usuário deletado com sucesso!')//sets the confirmation modal message
            changeStatus()//makes another api call
            setShow(false)//closes the main modal
            setShowProgress(false)//to disable the circular progress

        }).catch(error=>{
            setShowModalConfirm(false)//closes the first modal
            setShowConfirmAction(true)
            setTextConfirm('Erro ao excluir usuário!')
            setShowProgress(false)//to disable the circular progress

        })

    }
    /***************** */

    const sendNotifications = async(message, title, type) =>{
           
        await api.post('/admin/sendMessage', {
            message:message,
            title:title,
            type:type,
            uid: dataPJ.firebaseUID
        }, {
            headers: { 
                authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}` 
            }
        }).then(response=>
            console.log(response)
        ).catch(error=>{
            console.log(error)
        })
    
    }

    const sendEmail = async (text, subject) =>{

        const data = {
            email:dataPJ.email,
            text:text,
            subject:subject,
        }
    
        await api.post('/admin/sendEmail', data,
            {
                headers: {
                    authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
                },
            }
        ).then(response=>{
            
            console.log(response);
    
            // setShowAlertModal(false)//closes the first modal
            // setShowConfirmAction(true)//calls the confirmation modal
            // setTextConfirm('Alerta enviado com sucesso!')//sets the confirmation modal message
            // setShowProgress(false)//to disable the circular progress
    
        }).catch(error=>{
            console.log(error);
            setTextConfirm('Erro ao confirmar cadastro de ouvidoria!')
        })
    
    }

    return(
        <div>
            <Dialog
                open={show} 
                aria-labelledby="draggable-dialog-title" 
                maxWidth='md'
                onClose={()=>setShow(false)}
            >
                <DialogContent>
                    <div className='modal-pj'>
                        <div>
                            <img src={Cross} alt="" id='close-button' onClick={handleClose} className='cross-modal'/>
                        </div>
                        <h2 id='dados-do-local' className='modal-pj-title'>Dados do usuário</h2>

                        <div className='modal-pj-info'>
                            <p className='modal-header-description mgrtop1'>Nome do local: 
                                <p id='local-dados' className='modal-header-description des-color'> {dataPJ.establishment}</p>
                            </p>
                            <p className='modal-header-description mgrtop1'>Nome do representante: 
                                <p id='nome-dados' className='modal-header-description des-color'> {dataPJ.name}</p>
                            </p>
                            <p className='modal-header-description mgrtop1'>Email: 
                                <p id='email-dados' className='modal-header-description des-color'>{dataPJ.email}</p>
                            </p>
                            <p className='modal-header-description mgrtop1'>CPF: 
                                <p id='cpf-dados' className='modal-header-description des-color'> {dataPJ.cpf}</p>
                            </p>
                            <p className='modal-header-description mgrtop1'>RG: 
                                <p id='rg-dados' className='modal-header-description des-color'> {dataPJ.rg}</p>
                            </p>
                            <p className='modal-header-description mgrtop1'>Telefone: 
                                <p id='phone-dados' className='modal-header-description des-color'> {dataPJ.phone}</p>
                            </p>
                        </div>

                        <h2 id='endereco' className='modal-pj-title'>Endereço</h2> 
                        
                        <div className='modal-pj-info'>
                            <p className='modal-header-description mgrtop1'>CEP: 
                                <p id='cep-dados' className='modal-header-description des-color'> {dataPJ.cep?dataPJ.cep:"Não informado"}</p>
                            </p>
                            <p className='modal-header-description mgrtop1'>Logradouro: 
                                <p id='rua-dados' className='modal-header-description des-color'> {dataPJ.street?dataPJ.street:"Não informado"}</p>
                            </p>
                            <p className='modal-header-description mgrtop1'>Número: 
                                <p id='numero-dados' className='modal-header-description des-color'> {dataPJ.number?dataPJ.number:"Não informado"}</p>
                            </p>
                            <p className='modal-header-description mgrtop1'>Complemento: 
                                <p id='complemento-dados' className='modal-header-description des-color'> {dataPJ.complement?dataPJ.complement:"Não informado"}</p>
                            </p>
                            <p className='modal-header-description mgrtop1'>Bairro: 
                                <p id='bairro-dados' className='modal-header-description des-color'> {dataPJ.neighborhood?dataPJ.neighborhood:"Não informado"}</p>
                            </p>
                            <p className='modal-header-description mgrtop1'>Cidade: 
                                <p id='cidade-dados' className='modal-header-description des-color'>{dataPJ.city?dataPJ.city:"Não informado"}</p>
                            </p>
                            <p className='modal-header-description mgrtop1'>Estado: 
                                <p id='estado-dados' className='modal-header-description des-color'> {dataPJ.state?dataPJ.state:"Não informado"}</p>
                            </p>
                        </div>
                    
                        <hr/>

                        <div className='modal-pj-buttons'>
                            {   dataPJ.cpfStatus === "waiting for cpf upload" ?
                                <div id='nodocs-button' className='modal-pj-buttons-combo fasd'>
                                    <img src={RedDocs} alt=""/>
                                    <p>Documentos não fornecidos</p>
                                </div>
                                :
                                <div id='docs-button' className='modal-pj-buttons-combo' onClick={handleDocuments}>
                                    <img 
                                        src={DocumentsIcon}  
                                        style={
                                            {
                                                width: 50,
                                                marginLeft: 50,
                                                alignItems: 'center', 
                                                alignContent: 'center', 
                                            }
                                        }
                                        alt=""
                                    />
                                    <p>Ver Documentos</p>
                                </div>
                            }

                            {
                                dataPJ.blocked || isBlocked?                  
                                    <div id='bloq-button' className='modal-pj-buttons-combo' onClick={handleUnBlock}>
                                        <img 
                                            src={UnBlockIcon}  
                                            style={
                                                {
                                                    width: 50,
                                                    marginLeft: 40,
                                                    alignItems: 'center', 
                                                    alignContent: 'center', 
                                                }
                                            }
                                            alt=""
                                        />
                                        <p>Desbloquear</p>
                                    </div> 
                                    :
                                    <div id='bloq-button' className='modal-pj-buttons-combo mrgntop12' onClick={handleBlock}>
                                        <img 
                                            src={BlockIcon}  
                                            style={
                                                {
                                                    width: 40,
                                                    marginLeft: 20,
                                                    alignItems: 'center', 
                                                    alignContent: 'center', 
                                                }
                                            }
                                            alt=""
                                        />
                                        <p>Bloquear</p>
                                    </div> 
                            }

                            <div id='alert-button' className='modal-pj-buttons-combo' onClick={handleAlert}>
                                <img 
                                    src={AlertIcon}  
                                    style={
                                        {
                                            width: 50,
                                            marginLeft: 35,
                                            alignItems: 'center', 
                                            alignContent: 'center', 
                                        }
                                    }
                                    alt=""
                                />
                                <p>Emitir Alerta</p>
                            </div>

                            {
                                dataPJ.status === 'accepted' || approveRegister?
                                    <div id='aprovado-button' className='modal-pj-buttons-combo greenclr'>
                                         <img 
                                            src={GreenApproveIcon}  
                                            style={
                                                {
                                                    width: 50,
                                                    marginLeft: 35,
                                                    alignItems: 'center', 
                                                    alignContent: 'center', 
                                                }
                                            }
                                            alt=""
                                        />
                                        <p>Cadastro aprovado</p>
                                    </div> 
                                    :
                                    <div id='aprovar-button' className='modal-pj-buttons-combo darkclr' onClick={handleApprove}>
                                        <img 
                                            src={ApproveIcon}  
                                            style={
                                                {
                                                    width: 50,
                                                    marginLeft: 50,
                                                    alignItems: 'center', 
                                                    alignContent: 'center', 
                                                }
                                            }
                                            alt=""
                                        />
                                        <p>Aprovar cadastro</p>
                                    </div> 
                            }

                            <div id='excluir-button' className='modal-pj-buttons-combo redclr' onClick={handleDelete}>
                                <img 
                                    src={TrashIcon}  
                                    style={
                                        {
                                            width: 50,
                                            marginLeft: 40,
                                            alignItems: 'center', 
                                            alignContent: 'center', 
                                        }
                                    }
                                    alt=""
                                />
                                <p>Excluir usuário</p>
                            </div>
                            
                        </div>

                        
                    </div>
                </DialogContent>
            </Dialog>

            <Dialog
                open={showApprove} 
                aria-labelledby="draggable-dialog-title" 
                maxWidth='sm'
            >
                <DialogContent>
                    <h3 className='modal-pj-title'>Aprovar cadastro</h3> 
                    <div className='modal-confirm-approve'>
                        <img src={Confirm} onClick={handleApproveConfirm} alt=''className='confirm-button'/>
                        <img src={Decline} onClick={handleDenyApprove} alt='' className='confirm-button'/>
                    </div>
                </DialogContent>
            </Dialog>

            <ConfirmModal //asks if the user declines or accepts
                showModal={showModalConfirm}
                decline={setShowModalConfirm}
                alert={alertFunc}
                block={blockFunc}
                delete={deleteFunc}
                unblock={unblockFunc}
                approval={handleApproveConfirm}
                title={title}
                text={text}
                showProgress={showProgress}
                setShowProgress={setShowProgress}
            />

            <AlertModal //shows the alert options
                showModal={showAlertModal}
                decline={setShowAlertModal}
                alert={alertFunc}
                title={'Alerta'}
                setMessage={setAlertMessage}
                showProgress={showProgress}
                setShowProgress={setShowProgress}
            />

            <ConfirmAction // confirms the success of a action
                showModal={showConfirmAction}
                setShow={setShowConfirmAction}
                text={textConfirm}
            />

            <DocumentsModal //shows cpf 
                showModal={showDocuments}
                setShow={setShowDocuments}
                cpf={imgCPF}
                establishment={imgEstablishment}
            />
        </div>
    )
}